import '../../assets/css/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import React from 'react';

import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../components/layout/Style';
import CssBaseline from '@material-ui/core/CssBaseline';
import HeaderWebPage from './HeaderWebPage';
import BackToTop from '../../components/templates/BackToTop';
import FooterWebPage from './FooterWebPage';
import { INSTITUTIONAL_HEADER_MENU_ITEMS } from '../shared/headerMenus';

const ExcluirContaUsuario = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <div>
      <HeaderWebPage
        menuItems={INSTITUTIONAL_HEADER_MENU_ITEMS}
      />

      <section id="exclusao">
        <div className="exclusao-title-grid">
          <h1>Formulário de Exclusão de Conta de Usuário</h1>
        </div>

        <p>Sua opinião faz toda a diferença!</p>
        <p>Antes de seguir com a exclusão da sua conta, poderia nos contar o que não saiu como esperado? Escreva, em poucas palavras, o que poderíamos ter feito melhor.</p>

        {/*<p>Lamentamos não Para prosseguir com o pedido de exclusão da sua conta, informe seu e-mail e a justificativa do pedido.
          O pedido será analisado por nossa equipe e você receberá uma resposta por e-mail em até 15 dias.</p>*/}

        {/* Coluna do Formulário */}
        <div className="faca-parte-form">
          <form>

            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <input type="email" id="email" placeholder="seuemail@contato.com" required />
            </div>

            <div className="form-group">
              <label htmlFor="contato">Justificativa</label>
              <input type='text' id="justificativa" name="justificativa" rows="5" required placeholder='Escreva aqui...' />
            </div>

            <button type="submit" className="btn-enviar">
              Enviar Solicitação <i className="fas fa-paper-plane"></i>
            </button>
          </form>
        </div>
      </section>

      <FooterWebPage />

    </div>
    <BackToTop />
  </ThemeProvider>
)

export default ExcluirContaUsuario;
